import { ActionType } from '../infrastructure/actionTypes';
import { IProductIcon } from '../infrastructure/interfaces';

export default (list:Array<IProductIcon> = [], action: any) => {
  switch (action.type) {
    case ActionType.GET_PRODUCT_ICONS_DONE:
      list = action.productIconsList;
      return [...action.productIconsList];

    case ActionType.UPDATE_PRODUCT_ICON_DONE:
      list = list.map(d => {
        if (d.id !== action.iconData.id) {
            return d;
        }

        d.src = action.iconData.src;
        return d;
      });
      return list;

    default:
      return list;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/productIconsList.ts